<template>
  <div>
    <b-modal
      ref="transactionModal"
      header-class="header-gray"
      footer-class="footer-class"
      body-class="body-class"
      lazy
      size="lg"
      hide-footer
      :no-enforce-focus="true"
    >
      <template #modal-title>
        Transaction Details
      </template>
      <transaction :id="transactionId"></transaction>
    </b-modal>
    <b-modal
      ref="refundVoidModal"
      lazy
      size="sm"
      hide-footer
      :no-enforce-focus="true"
    >
      <template #modal-title>
        {{ refundVoidAction | title }} for {{ transaction.firstName }}
        {{ transaction.lastName }}
      </template>
      <refund-void
        :transaction="transaction"
        :refundVoidAction="refundVoidAction"
        v-on:refundVoidModalDone="refundVoidModalDone"
      ></refund-void>
    </b-modal>
    <table class="table mb-0" style="margin-top: -1px;">
      <thead>
        <tr>
          <th>&nbsp;</th>
          <th>Date</th>
          <th>Description</th>
          <th>Payment Method</th>
          <th class="text-right">Amount</th>
          <th class="text-right pr-0">Action</th>
        </tr>
      </thead>
      <tr v-for="item in paymentLedgers" v-bind:key="item.id">
        <td class="align-middle">
          <div v-if="!item.referenceId && item.description == 'Down Payment'">
            <i
              v-b-tooltip.hover
              title="Down Payment"
              style="font-size: 2em;color:#8898aa"
              class="fa-solid fa-circle-dollar-to-slot"
            ></i>
          </div>
          <div
            v-else-if="!item.referenceId && item.customerMembershipBillingId"
          >
            <i
              v-b-tooltip.hover
              title="Membership"
              style="font-size: 2em"
              class="text-muted icomoon icon-membership-system"
            ></i>
          </div>
          <div
            v-if="
              !item.referenceId &&
                item.paymentPlanId &&
                item.description != 'Down Payment'
            "
          >
            <i
              v-b-tooltip.hover
              title="Payment Plan"
              style="font-size: 2em"
              class="text-muted icomoon icon-recurring-system"
            ></i>
          </div>

          <disposition
            v-if="item.referenceId"
            :reason="item.reason"
            :status="item.status"
            :refundVoidType="item.refundVoidType"
            :id="item.referenceId"
          ></disposition>
        </td>
        <td class="align-middle">
          {{ item.dateTime | moment("MM/DD/YYYY") }}<br />
          <small>{{ item.dateTime | moment("hh:mm:ss A") }}</small>
        </td>
        <td class="align-middle">
          {{ item.description }}
        </td>
        <td class="align-middle">
          <card-svg :cardType="item.cardType" /> {{ item.cardDescription }}
        </td>
        <td class="text-right align-middle">
          <transaction-amount
            :amount="item.amount"
            :status="item.status"
            :refundVoidType="item.refundVoidType"
          ></transaction-amount>
        </td>
        <td class="text-right">
          <b-dropdown
            dropleft
            v-if="item.transactionResultId"
            variant="link"
            toggle-class="text-decoration-none"
            class=""
            no-caret
            size="lg"
            id="dropdown-1"
            text="Action"
          >
            <template #button-content
              ><i class="fas fa-ellipsis-h"></i>
            </template>

            <template
              v-if="
                !item.refundVoidType &&
                  !item.noAction &&
                  hasRole('PROCESSVOIDREFUND')
              "
            >
              <b-dropdown-item
                v-if="item.isSettled === true"
                @click.prevent="showRefundVoid(item, 'REFUND')"
              >
                <i class="icomoon icon-status-refunded text-warning"></i
                >Refund</b-dropdown-item
              >
              <b-dropdown-item
                v-if="item.isSettled === false"
                @click.prevent="showRefundVoid(item, 'VOID')"
              >
                <i class="icomoon icon-status-voided text-muted"></i
                >Void</b-dropdown-item
              >
            </template>

            <b-dropdown-item @click.prevent="showTransaction(item)">
              <i class="icomoon icon-details-system"></i>Transaction
              Details</b-dropdown-item
            >
          </b-dropdown>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import Transaction from "@/views/Components/Transactions/Transaction";
import RefundVoid from "@/views/Components/Transactions/RefundVoid";
export default {
  name: "payment-ledger",
  props: { paymentLedgers: null },
  components: { Transaction, RefundVoid },
  inject: ["hasRole"],
  mounted() {},
  watch: {
    paymentLedgers: {
      immediate: true,
      handler(newVal, oldVal) {
        var self = this;

        for (let item in self.paymentLedgers) {
          if (
            this.paymentLedgers[item].status == "APPROVED" &&
            this.paymentLedgers[item].referenceId
          ) {
            this.paymentLedgers[item].isSettled = null;
            self.isSettled(this.paymentLedgers[item]);
          } else {
            this.paymentLedgers[item].noAction = true;
          }
        }
      },
    },
  },

  computed: {
    // a computed getter
    balanceDue: function() {
      // `this` points to the vm instance
      var balanceDue =
        this.paymentLedgers.reduce((a, cv, ci, arr) => a + cv.amount, 0) / 100;
      if (balanceDue < 0) balanceDue = 0;

      return balanceDue;
    },
  },
  data() {
    return {
      transactionId: null,
      transaction: null,
      refundVoidAction: null,
    };
  },
  methods: {
    refundVoidModalDone() {
      this.$emit("rebind");
      this.$refs.refundVoidModal.hide();
    },
    showRefundVoid(transaction, action) {
      this.refundVoidAction = action;
      this.transaction = transaction;
      this.$refs.refundVoidModal.show();
    },
    showTransaction(transaction) {
      this.transactionId = transaction.transactionResultId;
      this.transaction = transaction;
      this.$refs.transactionModal.show();
    },
    isSettled(transaction) {
      var self = this;

      self.$client
        .get("/api/transaction/getTransaction?id=" + transaction.referenceId)
        .then((result) => {
          let t = self.paymentLedgers.find((a) => {
            return a.referenceId == transaction.referenceId;
          });

          t.isSettled = result.data.value.isSettled;
        });
    },
  },
};
</script>

<style>
.dropdown-menu .dropdown-item > .fa-pen {
  font-size: 0.8rem;
  position: relative;
  top: -2px;
}
</style>
